import moment from 'moment';

export class Utility {
    static ImageFileTypes = ['jpg', 'png', 'jpeg', 'gif', 'bmp', 'svg', 'ico', 'tiff', 'tif', 'heic', 'heif', 'avif', 'webp'];

    static isImage(fileName: string) {
        if (!fileName || !fileName.includes('.')) return false;

        const extension = fileName.split('.').pop();
        return Utility.ImageFileTypes.includes(extension);
    }

    static round(value: number, decimalPlaces: number = 0) {
        // negative numbers are rounded towards zero, which is wrong. To fix, convert value to positive, round, then convert back to negative
        return (Math.sign(value) * Math.round(Math.abs(value) * Math.pow(10, decimalPlaces))) / Math.pow(10, decimalPlaces);
    }



    static localToUtc(datetime: Date) {
        if (!datetime) return datetime;

        return moment(datetime).subtract(moment(datetime).utcOffset(), 'minutes').toDate();
    }

    static utcToLocal(datetime: Date) {
        if (!datetime) return datetime;
        else {
            return moment(datetime).add(moment(datetime).utcOffset(), 'minutes').toDate();
        }
    }

    static isAlphaNumeric(value) {
        // regex for alphanumeric only
        const re = /^[a-z0-9]+$/i;
        return !value || re.test(value);
    }

    static convertToAlphaNumeric(value: string): string {
        if (!value) return value;
        // regex for alphanumeric only
        const re = /[^a-z0-9]/gi;
        return value.replace(re, '');
    }

    static validateEmailAddresses(emails: string) {
        // regex that checks for comma separated emails. It does not allow for empty strings.
        const re = /^(\s?[^\s,]+@[^\s,]+\.[^\s,]+\s?,)*(\s?[^\s,]+@[^\s,]+\.[^\s,]+)$/g;
        return re.test(emails);
    }


}
